import {Component, Input, OnInit} from '@angular/core'
import {ContextService} from '@app/core/services/context.service'

@Component({
  selector: 'app-domain-field',
  templateUrl: './domain-field.component.html',
  styleUrls: ['./domain-field.component.scss'],
  standalone: false,
})
export class DomainFieldComponent implements OnInit {
  @Input()
  domain: string

  constructor(private context: ContextService) {}

  ngOnInit() {}

  selectDomain() {
    this.context.changeActiveDomain(this.domain)
  }
}
